<div class="bg-surface-0 dark:bg-surface-950 px-6 py-20 md:px-12 lg:px-20">
	<div
		class="p-12 shadow flex flex-col md:flex-row md:items-center justify-between bg-linear-to-r from-primary-600 to-primary-500/50">
		<div class="pr-12 flex flex-col gap-4">
			@if (content.title.length > 0){
			<h2
				class="text-3xl font-semibold text-surface-0 dark:text-surface-0"
				[innerHTML]="content.title"></h2>
			}
			<app-body-large
				[description]="content.description"
				class="text-surface-0! lg:text-lg!"></app-body-large>
		</div>
		<div class="mt-6 md:mt-0 md:w-auto w-full">
			@if (content.link){
			<app-link
				class="mt-4"
				[type]="content.link.type"
				[label]="content.link.title"
				bgColor="dark"
				(clicked)="ctaButtonClicked(content.link.path)"></app-link>
			}
		</div>
	</div>
</div>
